import { NumberMap } from '@login/interfaces';

export const WizardStage: NumberMap = {
  Email: 0,
  Password: 1,
  Company: 2
}
